import { useContext } from "react"
import { PLRecordContext } from "./PLRecordContext"

export const usePLRecordContext = () => {
  const context = useContext(PLRecordContext);

  if (!context) throw new Error('usePLRecordContext must be used inside PLRecordContext');

  return context;
}